import { makeStyles } from '@mui/styles';
import { get } from 'lodash';
import { TextField, useRecordContext } from 'react-admin';

import { SelectChipField, SelectChipFieldProps } from '@sh4res/bo-common/fields';

const useStyles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    gap: theme.spacing(),
  },
}));

export function SelectChipFieldsList(props: SelectChipFieldProps) {
  const { source, emptyText, 'data-testid': dataTestId, ...rest } = props;

  const classes = useStyles();
  const record = useRecordContext(props);

  if (source === undefined) {
    return null;
  }

  const value = get(record, source);

  if (!Array.isArray(value)) {
    return emptyText ? (
      <TextField data-testid={`${dataTestId}_EmptyText}`} emptyText={emptyText} />
    ) : null;
  }

  return (
    <div className={classes.list}>
      {value.length === 0 && emptyText && (
        <TextField data-testid={`${dataTestId}_TextField}`} emptyText={emptyText} />
      )}
      {value.map((_item, index) => (
        <SelectChipField
          data-testid={dataTestId}
          key={index}
          record={record}
          source={`${source}[${index}]`}
          {...rest}
        />
      ))}
    </div>
  );
}
